import { call, put, delay, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../services/apis";

export function* handleAddToCart({ payload }) {
  try {
    const res = yield call(API.addToCart, payload.data);
    const { data } = res;
    yield put(actions.addToCartSuccess(data));
    yield put(actions.fetchCart());
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.addToCartFailure(err?.response?.data));
  }
}

export function* handleFetchCart({ payload }) {
  try {
    const res = yield call(API.fetchCart);
    const { data } = res;
    yield put(actions.fetchCartSuccess(data));
    if (payload?.cb) payload.cb();
  } catch (err) {
    yield put(actions.fetchCartFailure(err?.response?.data));
  }
}

export function* handleUpdateCart({ payload }) {
  try {
    const res = yield call(API.updateCart, payload);
    const { data } = res;
    yield put(actions.updateCartSuccess(data));
  } catch (err) {
    yield put(actions.updateCartFailure(err?.response?.data));
  }
}

export function* handlePlaceOrder({ payload }) {
  const { cb } = payload;
  try {
    yield delay(500);
    const res = yield call(API.placeOrder, payload.data);
    const { data } = res;
    const orderId = data.body._id;
    yield put(actions.placeOrderSuccess(data));
    cb(orderId);
  } catch (err) {
    yield put(actions.placeOrderFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* cartSaga() {
  yield takeLatest(actions.addToCart.type, handleAddToCart);
  yield takeLatest(actions.fetchCart.type, handleFetchCart);
  yield takeLatest(actions.updateCart.type, handleUpdateCart);
  yield takeLatest(actions.placeOrder.type, handlePlaceOrder);
}
